import { render, staticRenderFns } from "./NoDelivery.vue?vue&type=template&id=799b43da&scoped=true"
import script from "./NoDelivery.vue?vue&type=script&lang=js"
export * from "./NoDelivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799b43da",
  null
  
)

export default component.exports